var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRpcStatusLowLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.66663H4.66667V14H2V8.66663Z",
    fill: "#D62F44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 6H9.33366V14H6.66699V6Z",
    fill: "rgba(13, 26, 22, 0.07)",
    fillOpacity: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.333 2H13.9997V14H11.333V2Z",
    fill: "rgba(13, 26, 22, 0.07)",
    fillOpacity: 1
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRpcStatusLowLight);
export default __webpack_public_path__ + "static/media/rpc-status-low-light.3d42ca46d013669bfc56506bbb6add79.svg";
export { ForwardRef as ReactComponent };